import { render, staticRenderFns } from "./Type1Box.vue?vue&type=template&id=37a7bde3&scoped=true"
import script from "./Type1Box.vue?vue&type=script&lang=js"
export * from "./Type1Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7bde3",
  null
  
)

export default component.exports